<template>
    <glm-layout>
        <world-map :specials="$page.props.mapCountries" height="200px">
            <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 flex items-center h-full justify-start">
                <div class="rounded-md max-w-lg inline-block p-2 bg-grey-700 text-white mt-3">
                    <h3 class="font-bold font-serif text-3xl">
                        Contact
                    </h3>
                </div>
            </div>
        </world-map>
    </glm-layout>
</template>

<script>
import NavBar from '@/Components/NavBar'
import GlmLayout from '@/Layouts/GlmLayout'
import WorldMap from '@/Components/WorldMap'

export default {
    components: {
        WorldMap,
        GlmLayout,
        NavBar,
    },

    data () {
        return {
            specials: [
                'AFG',
                'AGO',
                'ALB',
                'ARM',
                'AZE',
                'BDI',
                'BEN',
                'BFA',
                'BGD',
                'BOL',
                'BRA',
                'CAF',
                'CIV',
                'CMR',
                'COD',
                'COG',
                'COL',
                'COM',
                'DOM',
                'ECU',
                'ETH',
                'GAB',
                'GHA',
                'GIN',
                'GMB',
                'GTM',
                'GUY',
                'HND',
                'HTI',
                'IDN',
                'IND',
                'JOR',
                'KAZ',
                'KEN',
                'KGZ',
                'KHM',
                'LBR',
                'LKA',
                'LSO',
                'MAR',
                'MDA',
                'MDV',
                'MEX',
                'MGD',
                'MLI',
                'MMR',
                'MOZ',
                'MWI',
                'NAM',
                'NER',
                'NGA',
                'NIC',
                'NPL',
                'PAK',
                'PER',
                'PHL',
                'PNG',
                'PRY',
                'RWA',
                'SDN',
                'SEN',
                'SLE',
                'SLV',
                'STP',
                'TCD',
                'TGO',
                'THA',
                'TJK',
                'TLS',
                'TTO',
                'TUN',
                'TUR',
                'UGA',
                'UKR',
                'UZB',
                'VNM',
                'YEM',
                'ZAF',
                'ZMB',
                'ZWE',
            ],
        }
    },
}
</script>
